import { Box, Grid, Typography } from '@material-ui/core';
import {
  Autorenew as AutorenewIcon,
  EventNote as EventNoteIcon,
  EventAvailable as EventAvailableIcon,
  DateRange as DateRangeIcon,
} from '@material-ui/icons';
import { useFormikContext } from 'formik';
import React from 'react';
import { ActivityFormValues, ActivityTypeSelection } from '../ActivityFormV2';
import { ActivityTypeCard } from './ActivityTypeCard';

export const ActivityTypeStep = () => {
  const { values, setFieldValue } = useFormikContext<ActivityFormValues>();
  const selectedType = values.activityType;

  const handleSelect = (type: ActivityTypeSelection) => {
    setFieldValue('activityType', type);
    setFieldValue('isEvent', type === 'event');
    if (type === 'event') {
      setFieldValue('hasOpenRoster', true);
      setFieldValue('isRestrictedActivity', false);
      setFieldValue('frequency', undefined);
    } else if (type === 'once-off') {
      setFieldValue('frequency', 'no-repeat');
    } else if (type === 'regular') {
      setFieldValue('frequency', 'daily');
    } else if (type === 'flexible') {
      setFieldValue('frequency', undefined);
    }
  };

  return (
    <Box>
      <Typography style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>Activity Type</Typography>
      <Typography variant='body2' color='textSecondary'>
        Select the type of activity you are running. This will dictate how Volaby creates rosters.
      </Typography>

      <Grid container spacing={3} style={{ paddingTop: 16 }}>
        <Grid item xs={12} sm={6} md={3}>
          <ActivityTypeCard
            type='regular'
            icon={<AutorenewIcon fontSize='inherit' />}
            title='Regular'
            description='Repeating activities that recur with a similar time and structure.'
            example='eg. occurs daily, weekly, every Monday and Wednesday, monthly, etc.'
            selected={selectedType === 'regular'}
            onSelect={handleSelect}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <ActivityTypeCard
            type='once-off'
            icon={<EventAvailableIcon fontSize='inherit' />}
            title='Once-Off'
            description='An activity that only runs on one day and will not run again.'
            example='eg. 30th December, 2022'
            selected={selectedType === 'once-off'}
            onSelect={handleSelect}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <ActivityTypeCard
            type='flexible'
            icon={<DateRangeIcon fontSize='inherit' />}
            title='Flexible'
            description='Activities that occur with the same sessions, but can occur on varying or sporadic days and times.'
            example='eg. 30th December, 10th January, 13th January'
            selected={selectedType === 'flexible'}
            onSelect={handleSelect}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <ActivityTypeCard
            type='event'
            icon={<EventNoteIcon fontSize='inherit' />}
            title='Event'
            description='An activity that runs over one or more days. Volunteers can select their preferred sessions and dates when joining.'
            example='eg. 30th December - 2nd January'
            selected={selectedType === 'event'}
            onSelect={handleSelect}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
